/* src/components/landing/LpFeatures.jsx */
import React from 'react';
import { FEATURES, ICON_BG } from '../../data/landing';

export default function LpFeatures({ addReveal, revealStyle }) {
  return (
    <section id="features" className="s-pad" style={{ padding: '120px 0' }}>
      <div className="container">
        <div ref={addReveal} style={{ ...revealStyle, textAlign: 'center', maxWidth: 600, margin: '0 auto 64px' }}>
          <span className="section-label">Funcionalidades</span>
          <h2 className="serif s-title" style={{ fontSize: '2.8rem', marginBottom: 16 }}>Tudo que você precisa para fechar mais contratos</h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '1.1rem' }}>Ferramentas pensadas para quem vive o dia a dia do crédito imobiliário</p>
        </div>
        <div className="g3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
          {FEATURES.map((f, i) => (
            <div key={i} ref={addReveal} style={{ ...revealStyle, transitionDelay: `${0.1 * (i + 1)}s`, background: 'var(--surface)', borderRadius: 'var(--radius)', padding: '36px 30px', border: '1px solid transparent' }}>
              <div style={{ width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 20, fontSize: '1.3rem', background: ICON_BG[f.color] }}>{f.icon}</div>
              <h3 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: 10 }}>{f.title}</h3>
              <p style={{ fontSize: '0.9rem', color: 'var(--text-muted)', lineHeight: 1.65 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
